import React from 'react';
import { AuthHeader } from "./AuthHeader"
import { AuthLogin } from "./AuthLogin"
import { AuthReceipt } from "./AuthReceipt"
import { AuthPersonalId } from "./AuthPersonalId"
import { ErrorBanner } from "../common/ErrorBanner"

export const Auth = ({ ballot, isAuthReceipt, onValidateReceipt, isAuthPersonalId, onValidatePersonalId, onValidateLogin, authError }) => {
    // Get the right auth component to show
    const getAuthComponent = () => {
        if (isAuthReceipt) {
            return <AuthReceipt
                onValidateReceipt={onValidateReceipt} />
        }
        else if (isAuthPersonalId) {
            return <AuthPersonalId
                onValidatePersonalId={onValidatePersonalId}
                ballot={ballot} />
        }
        else {
            return <AuthLogin
                onValidateLogin={onValidateLogin}
                ballot={ballot} />
        }
    }

    return (
        <div className="/*min-h-screen*/ justify-center pt-12">
            <div className="mx-auto max-w-lg">
                <div className="bg-white py-8 px-10 shadow rounded-lg">
                    <AuthHeader ballot={ballot} />
                    {authError && <ErrorBanner>{authError}</ErrorBanner>}
                    {getAuthComponent()}
                </div>
            </div>
        </div>
    );
}